import IconRightArrow from '@atoms/IconRightArrow';
import { Divider, Text, View } from '@components/primitives';
import { FontAwesome } from '@expo/vector-icons';
import navigationConstants from '@navigation/navigationConstants';
import { useNavigation } from '@react-navigation/native';
import type { NativeStackNavigationProp } from '@react-navigation/native-stack';
import colors from '@theme/colors';
import AmplitudeHelper from '@utils/analytics';
import { AMPLITUDE_CONSTANTS } from '@utils/analytics/constants';
import { verticalScale } from '@utils/normalize';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TouchableOpacity } from 'react-native';

type BankDetails = {
  bankName: string;
  bankAccountName: string;
  bankAccountNumber: string;
  number: string;
};

type RootStackParamList = {
  [navigationConstants.BANK_LIST]: {
    defaultBank: BankDetails;
    source: string;
  };
};

type ProfileViewRegisteredBankDetailsProps = {
  source?: string;
  employeeDefaultBank?: Partial<BankDetails>;
};

const ProfileViewRegisteredBankDetails = ({
  source = '',
  employeeDefaultBank = {
    bankName: '',
    bankAccountName: '',
    bankAccountNumber: '',
    number: '',
  },
}: ProfileViewRegisteredBankDetailsProps) => {
  const { t } = useTranslation('common');
  const navigation = useNavigation<NativeStackNavigationProp<RootStackParamList>>();

  const handlePress = () => {
    const event = AMPLITUDE_CONSTANTS.bankRegistration.bank_page_clicked;
    AmplitudeHelper.logEvent(event.name, {
      [event.attributes.source]: source,
    });

    navigation.navigate(navigationConstants.BANK_LIST, {
      defaultBank: employeeDefaultBank as BankDetails,
      source,
    });
  };

  return (
    <View marginTop="12px">
      <TouchableOpacity testID="btnBanksListShow" onPress={handlePress} accessibilityRole="button">
        <View
          marginX="16px"
          borderColor={colors.disabled.smoke}
          borderWidth={1}
          borderRadius="12"
          justifyContent="center">
          <View marginLeft="12px" marginY="17px" flexDirection="row" alignItems="center">
            <FontAwesome name="bank" size={18} color="black" />
            <Text
              testID="txtRegisteredBanks"
              marginLeft="8px"
              variant="sm-bold"
              flex={1}
              color={colors.neutral.charcoal}>
              {t('profile.registeredBanks')}
            </Text>
            <View marginRight="16px">
              <IconRightArrow />
            </View>
          </View>
        </View>
      </TouchableOpacity>
      <Divider marginTop={verticalScale(8)} height="4px" backgroundColor={colors.neutral.mist} />
    </View>
  );
};

export default ProfileViewRegisteredBankDetails;
